module.exports = __webpack_public_path__ + "static/media/bell.ea9e32a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Header/components/Menu/bell.svg
// module id = 68
// module chunks = 0